import { Component, EventEmitter, Inject, input, Input, Output } from '@angular/core';
import { AddressFormComponent } from "../../form/address-form/address-form.component";
import { Customer, PostalAddressInterface } from "../../models/customer";
import { ModalService } from "@gea-waldviertler-website/shop-lib";

@Component({
    selector: 'gea-shop-address-tile',
    templateUrl: './address-tile.component.html',
    standalone: false
})
export class AddressTileComponent {

  @Input() address?: PostalAddressInterface
  @Input() addressTypeId?: number
  @Input() active: boolean = false
  @Input() showCrudControls?: boolean
  @Output("deleteAddress") deleteAddressEvent = new EventEmitter<PostalAddressInterface>()
  @Output("saveAddress") saveAddressEvent = new EventEmitter<PostalAddressInterface>()

  customer = input.required<Customer>()
  constructor(
    @Inject(ModalService) private modalService: ModalService,
  ) {
  }

  emitDeleteAddress(event: MouseEvent, address: PostalAddressInterface): void {
    event.stopPropagation()
    this.deleteAddressEvent.emit(address)
  }

  editAddress(event: MouseEvent, address: PostalAddressInterface): void {
    event.stopPropagation()
    let that = this

    let modal = this.modalService.show(AddressFormComponent, {
      title: "Adresse bearbeiten",
      inputs: {
        submitBtnText: "Speichern",
        address: address,
        customer: this.customer()
      },
      subscribers: {
        changeAddressEvent: function(address: PostalAddressInterface) {
          that.onAddressChange(address)
          modal.close()
        }
      }
    })
  }

  onAddressChange(address: PostalAddressInterface) {
    this.saveAddressEvent.emit(address)
  }
}
